export const onSubmit = (data, mutate, id_user) => {
    mutate({
        id_user,
        body: {
            departure_date: data.departure_date,
            notice_period_id: data.notice_period_id.id,
        },
    });
    return;
};
export const func_format_data_notice_period = (list_notice_periods = []) => {
    return list_notice_periods.map((list) => ({
        id: list.id,
        key: list.id,
        name: list.name,
        header: list.name,
    }));
};
